/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Desktop_HintInputs */

const cs_pwa_install_desktop_hint = /** @type {(inputs: Pwa_Install_Desktop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použijte ikonu instalace v adresním řádku, nebo menu prohlížeče → Nainstalovat Cerebrio / Nainstalovat aplikaci.`)
};

const en_pwa_install_desktop_hint = /** @type {(inputs: Pwa_Install_Desktop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the install icon in the address bar, or your browser’s menu → Install Cerebrio / Install app.`)
};

/**
* | output |
* | --- |
* | "Use the install icon in the address bar, or your browser’s menu → Install Cerebrio / Install app." |
*
* @param {Pwa_Install_Desktop_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_desktop_hint = /** @type {((inputs?: Pwa_Install_Desktop_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Desktop_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_desktop_hint(inputs)
	return cs_pwa_install_desktop_hint(inputs)
});